import React from "react";
import shop from "shop/shop";
import { Button, Table } from "semantic-ui-react";

export function ProductDownloads( { product } ) {
  const [resources, setResources] = React.useState( false )
  const [loading, setLoading] = React.useState( false )
  React.useEffect( () => {
    async function load() {
      setLoading( true )
      let res = await shop.fetch( `/shop/rest/data/v1/article/resources/${product.map_id}` )
      setResources( res )
      setLoading( false )
    }
    
    load()
  }, [product] )
  
  const isMedicineProduct = product.extras.Z_Medizinprodukt && product.extras.Z_Medizinprodukt.value.text === true
  
  return <div>
    {loading && <Button basic loading/>}
    {!loading && <div>
      {resources && resources.map( filePackage => {
        return <div key={filePackage.content}>
          <h4>{translate( "Zusatzinformationen für Medizinprodukte" )}</h4>
          <Table basic={"very"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  {translate( "Medizinprodukt" )}
                </Table.Cell>
                <Table.Cell>
                  {/*INTENTIONAL :) - 01/08/2022 see https://tickets.trend-soft.de/issues/3557 */}
                  {isMedicineProduct ? "Ja" : "Nein"}
                </Table.Cell>
              </Table.Row>
              {isMedicineProduct && <Table.Row>
                <Table.Cell>
                  {translate( "Medizinklasse" )}
                </Table.Cell>
                <Table.Cell>
                  {product.extras.Z_Medizinklasse && product.extras.Z_Medizinklasse.value.text}
                </Table.Cell>
              </Table.Row>}
              <Table.Row>
                <Table.Cell>
                  {translate( "Konformitätserklärung" )}
                </Table.Cell>
                <Table.Cell>
                  <Button basic size={"tiny"} as={"a"} target={"_blank"} download={filePackage.content}
                          href={`${shop.config.API}data/v1/article/resources/${product.map_id}/${filePackage.map_id}`}>download</Button>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      } )}
    </div>}
  </div>
}


// WEBPACK FOOTER //
// ./src/components/ProductDownloads.js